import React from "react";
import { Icon} from 'antd-mobile';
import "./selectDiv.scss"
import rl from '../../public/image/rl.png'
export default class SelectDiv extends React.Component{
    constructor(props){
        super(props);
        this.state={
            show:false,
            data:[],
            title:"",
            selectedvalue:""
        }
        
    }
    static defaultProps={
        value:'value',
        label:'name',
        data:[],
        showIcon:true,
        type:'select',
        title:""
    }
    changeType(s){
        if(this.props.type=='select'){
            this.setState({
                title:s[this.props.label],
                selectedvalue:s[this.props.value],
                show:!this.state.show
            },()=>{
                console.log("this.state....",this.state);
            });
            this.props.changeType(s);
        }
        
        
    }
    openClose(){
        if(this.props.type=='select'){
            let val=!this.state.show
            
            this.setState({
                show:val
            })
        }else{
            this.props.topDivClick()
        }
        
        
        
    }
    clear(){
        
        this.setState({
            selectedvalue:'',
            title:''
        })
        if(this.props.clear){
            this.props.clear()
        }
        
    }
    render(){
        let that=this;
        return(
            <div style={this.props.style} className="selectDiv" onClick={()=>{
                    this.openClose()
                }}>
                {
                    this.props.placeholder&&!this.state.title?<span className="placeholder">{this.props.placeholder}</span>:null
                }
                {
                    this.props.type=='text'&&<img style={{width:'4vw'}} src={rl}/>
                }
                
                <span  className="selectTitle">{this.state.title}</span>
                {(this.props.showIcon&&!this.state.selectedvalue)||(this.props.showIcon&&this.props.noIcon)?<Icon style={{color:'#B0B2BC'}}  type="down"/>:null}
                {this.state.selectedvalue&&!this.props.noIcon?<Icon onClick={(e)=>{e.stopPropagation();this.clear()}} style={{color:'#B0B2BC'}}  type="cross-circle"/>:null}
                {
                    this.state.show?
                    <ul className="selectList" onClick={(e)=>{e.stopPropagation()}}>
                        {
                            !this.state.data.length?
                            <li>暂无数据</li>:null
                        }
                        {/* <li  key={''}>请选择</li> */}
                        {this.state.data.map((s)=>{
                            return <li onClick={()=>{this.changeType(s)}} key={s[this.props.value]}>{s[this.props.label]}</li>
                        })}
                    </ul>:null
                }
                
            </div>
        )
    }
    componentWillReceiveProps(nextProps) {
        if(this.props.type=='select'){
            this.setState({
                data: nextProps.data
            });
        }else{
            this.setState({
                title: nextProps.title
            });
        }
        
        
    }
    componentDidMount(){
        // console.log("this.porps...",this.porps);
        if(this.props.onRef){
            this.props.onRef(this);
        }
        
        let that=this;
        if(this.props.type=='select'){
            let newarr=this.props.data.filter((s)=>{return s[this.props.value]==this.props.model})
            
            if(newarr.length){
                this.setState({
                    title:newarr[0][that.props.label]
                })
            }
            this.setState({
                data:this.props.data
            })
        }else if(this.props.type=='text'){
            this.setState({
                title:this.props.title
            })
        }
        
    }
}

